import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onPerformanceRecord(response) {
  return {
    type: types.PERFORMANCE_RECORD,
    response,
  };
}

export const fetchPerformanceRecord = async (jwtToken, dispatch) => {

  const body = {};
  dispatch(onPerformanceRecord({}));
  const url = 'api/GetSPR';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onPerformanceRecord(data));
    });
};
